<template>
    <div class="row">
      <div class="col-xl-2 col-md-4 col-lg-3 col-sm-6" v-for="(ders,i) in $store.getters.dersler" :key="ders.id">
        <div class="card  text-white mb-4" :class="`bg-${classNames[i]}`">
          <div class="card-body">{{ders.isim}}</div>
          <div class="card-text">
            <ul class="list-group">
              <router-link :to="`/${route.slug}/${ders.firebaseKey}`"  v-for="route in $store.getters.routes" :key="route.slug"><li :class="`list-group-item list-group-item-${classNames[i]}`">{{route.name}}</li></router-link>
            </ul>
          </div>

        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      classNames: {
        0: 'primary',
        1: 'dark',
        2: 'danger',
        3: 'warning',
        4: 'info'
      }

    }
  },
  created () {
    this.$emit('baslikchange', 'Anasayfa')
  }
}
</script>
